import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraOverlayDialog } from '@mono/ui-components/captains';
import { SpecraSelect } from '@mono/ui-components/ensigns';
import { SpecraFormField } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
/**
 * "Start from the agency's template?" (WRT-05 §8): shown when the RFI has
 * several .docx attachments and no choice was made yet. "Blank document" = 'blank'.
 */ export function TemplateChoiceDialog({ onChoose, options }) {
    const [value, setValue] = useState(options[0]?.attachmentId ?? 'blank');
    return /*#__PURE__*/ _jsx(SpecraOverlayDialog, {
        description: "The response document can start from one of the RFI's Word attachments, so your answers keep the agency's format.",
        footerProps: {
            confirmLabel: 'Create the response document',
            onConfirm: ()=>onChoose(value)
        },
        onOpenChange: ()=>{},
        open: true,
        size: "sm",
        testId: Testids.rfiWorkspace.templateChoice,
        title: "Start from the agency's template?",
        children: /*#__PURE__*/ _jsx(SpecraFormField, {
            label: "Start from",
            children: /*#__PURE__*/ _jsxs(SpecraSelect, {
                id: "rfi-template-choice",
                onChange: (e)=>setValue(e.target.value),
                value: value,
                children: [
                    options.map((o)=>/*#__PURE__*/ _jsx("option", {
                            value: o.attachmentId,
                            children: o.filename
                        }, o.attachmentId)),
                    /*#__PURE__*/ _jsx("option", {
                        value: "blank",
                        children: "Blank document"
                    })
                ]
            })
        })
    });
}
